export const LOAD_PAYMENT_TOKEN = "load_payment_token";
export const LOAD_PAYMENT_TOKEN_SUCCESS = "load_payment_token_success";
export const LOAD_PAYMENT_TOKEN_FAIL = "load_payment_token_fail";
